import { Heading, Paragraph } from '@zillow/constellation-10';

const VerificationFailedPage = (): JSX.Element | null => {
  return (
    <>
      <Heading level={3} textStyle="body-lg-bold">
        We could not create your payment
      </Heading>
      <Paragraph>
        We were currently unable to create your payment request. Contact our support team if you have more questions.
      </Paragraph>
    </>
  );
};

export default VerificationFailedPage;
